import useSyncFocusImplementation from './useSyncFocusImplementation';

export default useSyncFocusImplementation;
